import React, { useEffect } from "react";
import { ButtonV2, InputFormV2 } from "components";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { apiUpdateCurrent } from "api";
import { getCurrent } from "store/user/asyncActions";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import withBaseComponent from "hocs/withBaseComponent";
import { formatTime } from "utils/helpers";

const Profile = ({ navigate }) => {
  const {
    register,
    formState: { errors, isDirty },
    handleSubmit,
    reset,
    watch,
  } = useForm();
  const { current } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    reset({
      name: current?.name,
      phone: current?.phone,
      email: current?.email,
      avatar: current?.avatar,
      address: current?.address,
    });
  }, [current]);

  const handleUpdateInfor = async (data) => {
    const formData = new FormData();
    if (data.avatar.length > 0) formData.append("avatar", data.avatar[0]);
    delete data.avatar;
    for (let i of Object.entries(data)) formData.append(i[0], i[1]);
    const response = await apiUpdateCurrent(formData);
    if (response.success) {
      dispatch(getCurrent());
      toast.success(response.msg);
      if (searchParams.get("redirect")) navigate(searchParams.get("redirect"));
    } else toast.error(response.msg);
  };

  return (
    <div className="w-full relative px-4">
      <header className="text-3xl font-semibold py-4 border-b border-b-blue-200">
        Thông tin cá nhân
      </header>
      <form
        onSubmit={handleSubmit(handleUpdateInfor)}
        className="w-3/5 mx-auto py-8 flex flex-col gap-4">
        <InputFormV2
          label="Tên"
          register={register}
          errors={errors}
          id="name"
          validate={{
            required: "Need fill this field",
          }}
        />
        <InputFormV2
          disabled
          label="Email"
          register={register}
          errors={errors}
          id="email"
          validate={{
            required: "Need fill this field",
            pattern: {
              value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
              message: "Email invalid.",
            },
          }}
        />
        <InputFormV2
          disabled
          label="Số điện thoại"
          register={register}
          errors={errors}
          id="phone"
          validate={{
            required: "Need fill this field",
            pattern: {
              value:
                /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/gm,
              message: "Phone invalid.",
            },
          }}
        />
        <InputFormV2
          label="Địa chỉ"
          register={register}
          errors={errors}
          id="address"
          validate={{
            required: "Need fill this field",
          }}
        />
        {/* <div className="flex items-center gap-2">
          <span className="font-medium">Account status:</span>
          <span>{current?.isBlocked ? "Blocked" : "Actived"}</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="font-medium">Role:</span>
          <span>{+current?.role === 1945 ? "Admin" : "User"}</span>
        </div> */}
        <div className="flex items-center gap-2">
          <span className="font-medium">Ngày tham gia:</span>
          <span>{formatTime(current?.createdAt)}</span>
        </div>
        <div className="flex flex-col gap-2">
          <span className="font-medium">Ảnh đại diện:</span>
          <label htmlFor="file">
            <img
              src={current?.avatar}
              alt="avatar"
              className="w-20 h-20 ml-8 object-cover rounded-full"
            />
          </label>
          <input type="file" id="file" {...register("avatar")} hidden />
        </div>
        {isDirty && (
          <div className="w-full flex justify-end">
            <ButtonV2 type="submit">Lưu</ButtonV2>
          </div>
        )}
      </form>
    </div>
  );
};

export default withBaseComponent(Profile);
